import { motion } from "motion/react";
import { Target, Eye, Heart } from "lucide-react";
import { Card, CardContent } from "../components/ui/card";

export function About() {
  const unwtoGoals = [
    {
      number: 8,
      title: "Decent Work and Economic Growth",
      image: "/sdg8.png",
      description:
        "Promote sustained, inclusive economic growth, employment and decent work for all.",
    },
    {
      number: 10,
      title: "Reduced Inequalities",
      image: "/sdg10.png",
      description:
        "Reduce inequality within and among countries through inclusive development.",
    },
    {
      number: 12,
      title: "Responsible Consumption and Production",
      image: "/sdg12.png",
      description:
        "Ensure sustainable consumption and production patterns in tourism.",
    },
  ];

  // const timeline = [
  //   {
  //     year: "2022",
  //     title: "Foundation Established",
  //     description:
  //       "Immerse Foundation was created as the philanthropic arm of Immerse India Tours.",
  //   },
  //   {
  //     year: "2023",
  //     title: "First Projects Funded",
  //     description:
  //       "Launched funding for 5 grassroots projects across rural India.",
  //   },
  //   {
  //     year: "2024",
  //     title: "Expanded Reach",
  //     description: "Partnered with 20+ NGOs and impacted 10,000+ lives.",
  //   },
  //   {
  //     year: "2025",
  //     title: "International Recognition",
  //     description:
  //       "Received UNWTO certification for sustainable tourism development.",
  //   },
  //   {
  //     year: "2026",
  //     title: "Growing Impact",
  //     description:
  //       "Currently funding 47 projects with 32 partner organizations.",
  //   },
  // ];

  // const boardMembers = [
  //   {
  //     name: "Ujjwal",
  //     role: "Founder & Chairperson",
  //     image:
  //       "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop",
  //   },
  //   {
  //     name: "Priya Patel",
  //     role: "Director of Operations",
  //     image:
  //       "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop",
  //   },
  //   {
  //     name: "Sunil Verma",
  //     role: "Director of Impact Assessment",
  //     image:
  //       "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop",
  //   },
  //   {
  //     name: "Anjali Sharma",
  //     role: "Financial Advisor",
  //     image:
  //       "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop",
  //   },
  // ];

  return (
    <div>
      {/* Hero Section */}
      <section
        className="relative overflow-hidden py-32 text-primary-foreground"
        style={{
          backgroundImage:
            "linear-gradient(rgba(15, 23, 42, 0.45), rgba(15, 23, 42, 0.45)), url('/about.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-4xl"
          >
            <h4 className="text-3xl md:text-3xl mb-6">Empowering communities. Enabling change. Sustaining impact.</h4>
            <p className="text-xl md:text-2xl opacity-90 leading-relaxed">
              We bring together individuals, institutions, and partners to create opportunities and deliver meaningful, sustainable change for local communities.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <Card className="h-full bg-primary text-primary-foreground">
                <CardContent className="p-12">
                  <Target size={48} className="mb-6" />
                  <h2 className="text-3xl mb-4">Our Mission</h2>
                  <p className="text-lg leading-relaxed opacity-90">
                    Empowering rural communities through foundation-led on-ground initiatives in education, skills, and sustainable livelihoods.
                  </p>
                </CardContent>
              </Card>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <Card className="h-full bg-accent text-accent-foreground">
                <CardContent className="p-12">
                  <Eye size={48} className="mb-6" />
                  <h2 className="text-3xl mb-4">Our Vision</h2>
                  <p className="text-lg leading-relaxed">
                    To create a future where every rural community is empowered through education, opportunity, and sustainable growth.
                  </p>
                </CardContent>
              </Card>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Our Approach */}
      <section className="bg-[#f5f4f3] py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl md:text-5xl mb-4">Our Approach</h2>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              We are a foundation-led initiative provide support, and strengthen on-ground community programs.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <img
                src="https://images.unsplash.com/photo-1564069970419-0bc8e7b487da?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxoYW5kc2hha2UlMjBwYXJ0bmVyc2hpcCUyMGNvbGxhYm9yYXRpb24lMjBkaXZlcnNlfGVufDF8fHx8MTc3NDg3MDQ3Nnww&ixlib=rb-4.1.0&q=80&w=1080"
                alt="Partnership"
                className="rounded-lg shadow-xl"
              />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="space-y-6"
            >
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                  <Heart className="text-primary" size={24} />
                </div>
                <div>
                  <h3 className="text-xl mb-2">Selection & Support </h3>
                  <p className="text-muted-foreground">
                    We identify and collaborate with credible grassroots organisations aligned with our mission and impact goals.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                  <Heart className="text-primary" size={24} />
                </div>
                <div>
                  <h3 className="text-xl mb-2">Partnership & Collaboration</h3>
                  <p className="text-muted-foreground">
                    We work with individuals and institutions who contribute through knowledge, mentorship, and resources to strengthen initiatives.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                  <Heart className="text-primary" size={24} />
                </div>
                <div>
                  <h3 className="text-xl mb-2">Implementation & Impact</h3>
                  <p className="text-muted-foreground">
                    Programs are implemented through on-ground partners, with regular updates and impact tracking to ensure transparency and learning.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                  <Heart className="text-primary" size={24} />
                </div>
                <div>
                  <h3 className="text-xl mb-2">Foundation-Backed Model</h3>
                  <p className="text-muted-foreground">
                    All operational support is managed independently by the foundation ecosystem, ensuring focus remains on community impact.
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* UNWTO Goals */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl md:text-5xl mb-4">Aligned with UNWTO Goals</h2>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              Every project we fund contributes to these sustainable development
              goals
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {unwtoGoals.map((goal, index) => (
              <motion.div
                key={goal.number}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                <Card className="h-full hover:shadow-lg transition-shadow">
                  <CardContent className="p-8">
                    <div className="w-20 h-20 rounded-2xl overflow-hidden bg-white shadow-sm mb-6 flex items-center justify-center">
                      <img
                        src={goal.image}
                        alt={`SDG ${goal.number}`}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="text-primary mb-2">SDG {goal.number}</div>
                    <h3 className="text-xl mb-3">{goal.title}</h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {goal.description}
                    </p>
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline */}
      {/* <section className="py-24 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl md:text-5xl mb-4">Our Journey</h2>
          </motion.div>

          <div className="space-y-12">
            {timeline.map((item, index) => (
              <motion.div
                key={item.year}
                initial={{ opacity: 0, x: index % 2 === 0 ? -30 : 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                className="flex gap-8 items-start"
              >
                <div className="flex-shrink-0 w-24 text-3xl text-primary">
                  {item.year}
                </div>
                <div className="flex-1 pb-12 border-l-2 border-border pl-8 relative">
                  <div className="absolute -left-2.5 top-2 w-5 h-5 rounded-full bg-primary" />
                  <h3 className="text-2xl mb-2">{item.title}</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Board Members */}
      {/* <section className="py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl md:text-5xl mb-4">Our Leadership</h2>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {boardMembers.map((member, index) => (
              <motion.div
                key={member.name}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="text-center"
              >
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-48 h-48 rounded-full mx-auto mb-4 object-cover"
                />
                <h3 className="text-xl mb-1">{member.name}</h3>
                <p className="text-muted-foreground">{member.role}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Partners */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl md:text-5xl mb-4">Our Partner Organizations</h2>
            <p className="text-xl text-muted-foreground">
              Collaborating with NGOs, institutions, and partner organisations
            </p>
          </motion.div>

          <div className="grid grid-cols-2 gap-10 md:grid-cols-3 lg:grid-cols-4 place-items-center">
            <div className="flex justify-center items-center">
            <motion.img
              src="/patnerlogo.png"
              alt="Partner Organization"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4 }}
              className="h-24 w-auto object-contain"
            />
          </div>
          </div>
        </div>
      </section>
    </div>
  );
}
